import { useNavigate } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Chip from "@mui/material/Chip";
import HomeIcon from "@mui/icons-material/Home";
import { styled } from "@mui/material/styles";
const StyledBreadcrumb = styled(Chip)(({ theme }) => {
  const backgroundColor =
    theme.palette.mode === "light"
      ? theme.palette.grey[100]
      : theme.palette.grey[800];
  return {
    backgroundColor,
    height: theme.spacing(3),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
  };
}) as typeof Chip;

export const BreadcrumbBar = () => {
  const nav = useNavigate();
  const goToDashboard = () => {
    setTimeout(() => {
      nav("/");
    }, 0);
  };
  const goToUserList = () => {
  setTimeout(() => {
    nav("/config/user/list");
  }, 0);
};

  let pathName = window.location.pathname.toLowerCase();

  if (window.location.pathname.slice(-1) === "/") {
    pathName = pathName.replace(/.$/, "");
  }

  const pathnames = pathName.split("/").filter((x) => x);
  const id = pathnames.slice(-1)[0];

  const breadcrumbNameMap: { [key: string]: string } = {
    "/lease": "",
    "/lease/form/new": "Form",
    ["/lease/form/view/" + id]: "Form",
    ["/lease/form/edit/" + id]: "Form",
    ["/lease/form/approval/" + id]: "Form",
    "/config/rawdata": "Raw Data",
    "/config/user/list": "User Role Map",
    ["/config/user/view/" + id]: "Form",
    ["/config/user/edit/" + id]: "Form",
    "/config/user/new" : "Form",
  };

  return (
    <div role="presentation" className="mt-05">
      <Breadcrumbs aria-label="breadcrumb" className="breadcrumb">
        <StyledBreadcrumb
          
          onClick={() => goToDashboard()}
          icon={<HomeIcon fontSize="small" />}
        />
        {(pathName.includes("/config/user/") && pathName !== "/config/user/list") && (
        <StyledBreadcrumb
          label="User Role Map"
          onClick={() => goToUserList()}
          component="a"
        />
      )}
        {breadcrumbNameMap[pathName] && (
          <StyledBreadcrumb label={breadcrumbNameMap[pathName]} component="a" />
        )}
      </Breadcrumbs>
    </div>
  );
};
